export function preferencesServerJson (language) {
  let items

  if (language === 'es') {
    items = {
      viewLicensesMdm: {
        name: 'viewLicensesMdm',
        label: 'ver y sincronizar las licencias de los dispositivos asignadas al MDM'
      }
    }
  } else if (language === 'en') {
    items = {
      viewLicensesMdm: {
        name: 'viewLicensesMdm',
        label: 'view and synchronize device licenses assigned to the MDM'
      }
    }
  }
  return (items)
}

// editMdmPreferences: {
//       name: 'editMdmPreferences',
//       label: 'editar las preferencias del MDM del servidor'
//     },
//     editSafeWebPreferences: {
//       name: 'editSafeWebPreferences',
//       label: 'editar las preferencias de Safeweb del servidor'
//     },
//     editRxartSecurePreferences: {
//       name: 'editRxartSecurePreferences',
//       label: 'editar las preferencias de Rxart Secure del servidor'
//     },
